import { ApiResource } from '@/core/models/api-resource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import exists, { ExistsState } from './exists/exists.store';
import { Hit } from './hit.interface';
import { HitService } from './hit.service';

const service = new HitService();

export interface HitState {
   hitsOverview?: ApiResource<Array<Hit>>;
   exists?: ExistsState;
}

const HitStore: Module<HitState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async createHit(context, hit: Hit) {
         const response = await service.postHit(hit);
         return response;
      },
      async getHitActivities(context, payload: { hitId: number; query: LocationQuery }) {
         const response = await service.getHitActivities(payload.hitId, payload.query);
         return response.data;
      },
      async patchHit(context, { hitId, value, path }: { hitId: number; value: string | boolean | null; path: string }) {
         const response = await service.patchHit(hitId, path, value);
         return response;
      },
      async deleteHit(context, hitId: number) {
         const response = await service.deleteHit(hitId);
         return response;
      },
      async deleteHitBulk(context, hitIds: Array<number>) {
         const response = await service.deleteHitBulk(hitIds);
         return response;
      },
   },
   modules: {
      exists,
   },
};

export default HitStore;
